import {extractYouTubeId} from './youtube';
import type {Item} from '@/api/items';

/**
 The platform's own id for an item - the video id for content, the channel/profile id for an
 actor. Mirrors the derivation the item card/row already renders from (extractYouTubeId), so a
 copied id is the one the analyst can see. Non-YouTube urls fall through to external_id, which is
 the platform's content id on every platform.
 */
export function itemPlatformId(item: Item): string {
  return item.content_type === 'actor'
    ? (item.author_id ?? item.external_id)
    : (extractYouTubeId(item.url, item.external_id) ?? item.external_id);
}

/** Newline-joined ids in the order given, de-duplicated - pastes into one spreadsheet column. */
export function itemIdsForClipboard(items: readonly Item[]): string {
  return [...new Set(items.map(itemPlatformId))].join('\n');
}
